import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ACCTA = () => {
  return (
    <section className="py-24 bg-[#4D4C4A] text-white relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <Image 
          src="/assets/images/AC-page/AC-1080px-by-1080px-3.jpg" 
          alt="AC Service CTA" 
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#4D4C4A] via-[#4D4C4A]/90 to-transparent"></div>
      </div>

      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-5 pointer-events-none z-10">
        <Icon name="Wind" size={500} className="text-white" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Schedule Your Service</h2>
            <h3 className="text-4xl md:text-6xl font-bold italic tracking-tighter mb-10 leading-[1.1]">
              Keep Your Cooling Systems <br /> 
              Running <span className="text-[#91756A]">Efficiently</span>.
            </h3>
            <p className="text-white/60 text-lg md:text-xl leading-relaxed mb-12 max-w-2xl font-light italic">
              Our engineering team ensures your HVAC systems remain reliable, energy-efficient, and ready to perform in demanding environments.
            </p>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="flex flex-col sm:flex-row gap-6"
            >
              <Link to="/contact-consultation">
                <Button 
                  variant="default" 
                  className="bg-[#91756A] hover:bg-[#a1857a] text-white px-12 py-8 rounded-none text-sm font-bold uppercase tracking-[0.3em] h-auto group"
                >
                  Schedule Inspection
                  <Icon name="ArrowRight" size={16} className="ml-3 group-hover:translate-x-2 transition-transform duration-300" />
                </Button>
              </Link>
              <a href="tel:+971544411179">
                <Button 
                  variant="outline" 
                  className="border-white/20 text-white hover:bg-white/5 px-12 py-8 rounded-none text-sm font-bold uppercase tracking-[0.3em] h-auto"
                >
                  Call +971 5444 111 79
                </Button>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Modern Accent Line */}
      <motion.div 
        initial={{ width: 0 }}
        whileInView={{ width: "100%" }}
        viewport={{ once: true }}
        transition={{ duration: 2, ease: "easeInOut" }}
        className="absolute bottom-0 left-0 h-1 bg-[#91756A]"
      ></motion.div>
    </section>
  );
};

export default ACCTA;